
const portalRoutes = [
  {
    path: "/",
    name: "public-portal",
    component: () => import("../views/public/portal.vue"),
    meta: {
      title: "Portail Public PADMAR-E",
      authRequired: false,
        cible: "prima",
    },
  },
  {
    path: "/folders/:slug",
    name: "public-folder",
    component: () => import("../views/public/PublicFolder.vue"),
    meta: {
      title: "Dossier Public",
      authRequired: false,
      cible: "prima",
    },
  },
  // Route catch-all pour rediriger vers le portail principal
  {
    path: "/:pathMatch(.*)*",
    name: "portal-not-found",
    redirect: "/"
  }
];

export default portalRoutes;